import { api } from './base-api';
import {
  ClienteDetail,
  ClientesFilters,
  PaginatedClientes,
  ManualKycApprovalResponse,
} from '../../types/cliente';

const cleanParams = (filters: Record<string, unknown>) => {
  const result: Record<string, string | number | boolean> = {};
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null || value === '') continue;
    result[key] = value as string | number | boolean;
  }
  return result;
};

export interface ListClientesParams extends Partial<ClientesFilters> {
  page?: number;
  limit?: number;
}

export const clientesApi = {
  async list(params: ListClientesParams = {}): Promise<PaginatedClientes> {
    const { data } = await api.get<PaginatedClientes>('/admin/clientes', {
      params: cleanParams({ ...(params as Record<string, unknown>) }),
    });
    return data;
  },

  async detail(id: string): Promise<ClienteDetail> {
    const { data } = await api.get<ClienteDetail>(`/admin/clientes/${id}`);
    return data;
  },

  async approveKycManually(id: string): Promise<ManualKycApprovalResponse> {
    const { data } = await api.post<ManualKycApprovalResponse>(
      `/admin/clientes/${id}/kyc/manual-approval`
    );
    return data;
  },
};
